import script from "./WaizmannEmpfehlung.vue?vue&type=script&setup=true&lang=js"
export * from "./WaizmannEmpfehlung.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__